module.exports = __webpack_public_path__ + "static/media/arena-web.3b89e3e5.png";